export default function FormErrorMessage({ message }: { message: string | undefined }) {
  return (
    <p className="ms-1 mt-1.5 text-xs text-danger" role="alert">
      {message}
    </p>
  );
}
